module.exports = __webpack_public_path__ + "img/compu-minutes-editor-hover.3c355d52.svg";